import { useState } from 'react';
import './wiz-button.scss';

export default function WizButton({ variant = 'primary', children, onClick, className = '', ...props }) {
  const [isPressed, setIsPressed] = useState(false);
  
  const handleClick = (e) => {
    setIsPressed(true);
    
    // Reset the animation after it completes
    // Using a shorter duration for a snappier feel
    setTimeout(() => {
      setIsPressed(false);
    }, 150);
    
    // Call the original onClick handler if provided
    if (onClick) {
      onClick(e);
    }
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };
  
  return (
    <button 
      className={`wiz-button ${isPressed ? 'wiz-button--pressed' : ''} ${variant === 'secondary' ? 'wiz-button--secondary' : ''} ${className}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      aria-label="Wiz Button"
      {...props}
    >
      <span>{children}</span>
    </button>
  );
}